import app_config from '@/app_config'
import Bitrix24 from '@/lib/Bitrix24'
import urls from '@/lib/urls'
import axios from 'axios'

function errorHandler(error){
  if(typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined'){
    return error.response.data
  } else{
    return error
  }
}

function errorQueryHandler(error){
  let obj = {}
  if(typeof error.response !== 'undefined' && typeof error.response.status !== 'undefined'){
    if(error.response.status === 403){
      localStorage.removeItem('token')
      obj = {
        type: 'unauthorization',
        error: error
      }
      return obj
    } else{
      obj = {
        type: 'some',
        error: error
      }
      return obj
    }
  } else{
    obj = {
      type: 'danger',
      error: error
    }
    return obj
  }
}

function setDevHeaders(){
  let config = {}
  if(app_config.mode === 'dev'){
    config = {
      headers: {
        'TrackerSession': "I'm admin"
      }
    }
  }
  return config
}

async function setAuthorizationHeader(){
  if(typeof localStorage.token !== "undefined" && typeof localStorage.token !== 'null' && typeof localStorage.token !== null){
    let token = localStorage.token
    let auth_info = await Bitrix24.getAuthInfo()
    if(auth_info){
      let domain = auth_info.domain
      let config = {
        headers: { 
          Authorization: `Bearer ${token}`,
          "X-Bitrix-Domain": domain
        }
      }
      return config
    }
  } else{
    return ''
  }
}

function authorization(token, domain){
  return new Promise((resolve, reject) => {
    if(typeof localStorage.token !== "undefined" && typeof localStorage.token !== 'null'){
      let obj = {
        status: true,
        data: {
          token: localStorage.token
        }
      }
      resolve(obj)
    } else{
      axios.get(urls.authURL(token, domain)).then(response => {
        if(typeof response !== 'undefined' && typeof response.data !== 'undefined' && typeof response.data.token !== 'undefined'){
          localStorage.setItem('token', response.data.token)
          let obj = {
            status: true,
            data: response.data
          }
          resolve(obj)
        } else{
          reject('Ошибка авторизации')
        }
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    }
  })
}

function queryRefreshToken(error){
  return new Promise((resolve, reject) => {
    Bitrix24.refreshAuthInfo().then(auth_info => {
      let domain = auth_info.domain
      let token = auth_info.access_token
      authorization(token, domain).then(response => {
        error.config.headers["Authorization"] = "Bearer " + response.data.token
        error.config.headers["X-Bitrix-Domain"] = domain
        axios.request(error.config).then(response => {
          resolve(response)  
        }).catch(err => {
          reject(false)
        })
      }).catch(err => {
        reject(false)
      })
    }).catch(err => {
      console.log(err)
      reject(false)
    })
  })
  
}

export default {
  setDevHeaders,
  errorHandler,
  setAuthorizationHeader,
  queryRefreshToken,
  authorization,
  errorQueryHandler
}
